import React from 'react';

import { ErrorView } from '../../components/error-view/error-view';
import { RouteContainer } from '../helpers/styled';
import { PromoBanner } from './components/promo-banner/promo-banner';
import { ThreeEssentialsWelcomePage } from './components/three-essentials-welcome-page/three-essentials-welcome-page';
import { useWelcomeRoute } from './hooks';
import {
    WelcomePageContainer,
    WelcomePageRow
} from './welcome-route.styled';

export const WelcomeRoute = () => {
    const { isError } = useWelcomeRoute();

    if (isError) return <ErrorView />;

    return (
        <RouteContainer>
            <WelcomePageContainer>
                <PromoBanner />
                <WelcomePageRow>
                    <ThreeEssentialsWelcomePage />
                </WelcomePageRow>
            </WelcomePageContainer>
        </RouteContainer>
    );
};

